import { RootState } from "../root.reducer";

export const searchQuerySelector = (state: RootState) => state.searchQuery;
